import {Component} from '@angular/core';

@Component({
    templateUrl: './emptydemo.component.html'
})
export class EmptyDemoComponent {
}



// WEBPACK FOOTER //
// ./src/app/demo/view/emptydemo.component.ts